import { render, staticRenderFns } from "./MaterialToggleItem.vue?vue&type=template&id=0ef2f8d2&scoped=true&"
import script from "./MaterialToggleItem.vue?vue&type=script&lang=js&"
export * from "./MaterialToggleItem.vue?vue&type=script&lang=js&"
import style0 from "./MaterialToggleItem.vue?vue&type=style&index=0&id=0ef2f8d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef2f8d2",
  null
  
)

export default component.exports